import { useEffect, useState } from "react";
import { ControlledConnectionsList } from "../controlled-components/ControlledConnectionsList";
import { ControlledConnectionForm } from "../controlled-components/ControlledConnectionForm";
import { ControlledOauthConnection } from "../controlled-components/ControlledOauthConnection";

export const MainSection = ({
  setIsWhiteLabel,
  isWhiteLabel,
}: {
  setIsWhiteLabel: (value: boolean | null) => void;
  isWhiteLabel: boolean | null;
}) => {
  interface MessageData {
    linkTokenEndpoint: string;
    linkHeaders?: Record<string, unknown>;
    title?: string;
    selectedConnection?: number | string;
    showNameInput?: boolean;
    imageUrl?: string;
    companyName?: string;
  }

  const [messageData, setMessageData] = useState<MessageData>();
  const [integrationId, setIntegrationId] = useState<number | undefined>();
  const [clientId, setClientId] = useState<string | undefined>();
  const [secretId, setSecretId] = useState<string | undefined>();
  const [connectionGuide, setConnectionGuide] = useState<string>();
  const [sessionId, setSessionId] = useState<string>("");
  const [requestId, setRequestId] = useState<number>();
  const [useDefaultOauthCreds, setUseDefaultOauthCreds] = useState<boolean>(false);

  useEffect(() => {
    const queryParameters = new URLSearchParams(
      window?.location?.href.split("?")[1]
    );

    const base64Decoded = queryParameters.get("data") || "";

    if (base64Decoded) {
      const jsonDecoded = atob(base64Decoded);
      const decodedObject = JSON.parse(jsonDecoded);
      setMessageData(decodedObject);
      setIntegrationId(undefined);
    }
  }, []);
  
  return (
    <>
      {secretId && (clientId || useDefaultOauthCreds) && integrationId && messageData && requestId && (
        <ControlledOauthConnection
          integrationId={integrationId}
          setIntegrationId={setIntegrationId}
          secretId={secretId}
          setClientId={setClientId}
          showNameInput={messageData?.showNameInput}
          selectedConnection={messageData?.selectedConnection}
          connectionGuide={connectionGuide}
          requestId={requestId}
          linkHeaders={messageData.linkHeaders}
          imageUrl={messageData?.imageUrl}
          companyName={messageData?.companyName}
          isWhiteLabel={isWhiteLabel}
        />
      )}
      {integrationId && messageData && !clientId && !useDefaultOauthCreds && (
        <ControlledConnectionForm
          definitionId={integrationId}
          setIntegrationId={setIntegrationId}
          selectedConnection={messageData.selectedConnection}
          showNameInput={messageData.showNameInput ?? false}
          connectionGuide={connectionGuide}
          requestId={requestId}
          linkHeaders={messageData.linkHeaders}
          isWhiteLabel={isWhiteLabel}
        />
      )}
      {!integrationId && messageData && !clientId && (
        <ControlledConnectionsList
          linkTokenEndpoint={messageData.linkTokenEndpoint}
          linkHeaders={messageData.linkHeaders}
          setIntegrationId={setIntegrationId}
          setClientId={setClientId}
          setSecretId={setSecretId}
          setConnectionGuide={setConnectionGuide}
          title={messageData.title}
          selectedConnection={messageData.selectedConnection}
          setSessionId={setSessionId}
          sessionId={sessionId}
          setRequestId={setRequestId}
          setUseDefaultOauthCreds={setUseDefaultOauthCreds}
          setIsWhiteLabel={setIsWhiteLabel}
        />
      )}
    </>
  );
};
